module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/tiktok-icon-36.b67ff70e174cc234.png"+" 36w",
        images: [{path: "https://static.sniffspot.com/packs/img/tiktok-icon-36.b67ff70e174cc234.png",width: 36,height: 40}],
        src: "https://static.sniffspot.com/packs/img/tiktok-icon-36.b67ff70e174cc234.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/tiktok-icon-36.b67ff70e174cc234.png"},
        
        width: 36,
        height: 40
      }